import React, { memo, useEffect, useReducer, useState } from 'react'
import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList'
import useDashboardFilterHook from '../Shared/useDashboardFilterHook'
import { ServerRequestProtected } from '../../../../utils/ServerDataRequest'
import { enumUtil } from '../../../../utils/Enum'
import AmountFormatter from '../../../../utils/AmountFormatter'
import DownloadCSVLink from '../../../../utils/DownloadCSVLink'
import GridColumnHeader from '../../../Setup/Shared/GridColumnHeader'
import Table from '../../../Setup/Shared/Table'
import BarChart from '../Charts/BarChart'

const paymentForList = [
  { value: 'System Visits', display: 'System Visits' },
  { value: 'External Visits', display: 'External Visits' },
  { value: 'All', display: 'All' },
]

const API_URL = enumUtil.controller.Dashboard

const Aging = memo((props) => {
  const { reloadData, isHomeCareCheck } = props;

  const [is, setIs] = useState(true);
  const [agingPaymentReceivedData, setAgingPaymentReceivedData] = useState([]);
  const [agingPaymentReceivedDataSorting, setAgingPaymentReceivedDataSorting] = useState([]);
  const [isLoadingAging, setIsLoadingAging] = useState(false);
  const [activeTab, setActiveTab] = useState('Graph');
  const [reloadChart, setReloadChart] = useState(false);

  const [PaymentForAgingDisplay, setPaymentForAgingDisplay] = useState('All');
  const [baseOnAgingDisplay, setBaseOnAgingDisplay] = useState('Date of Service');

  const [gridHeaderAging, handleGridHeaderAging] = useReducer((prev, next) => {
    return { ...prev, ...next }
  }, { defaultData: '', activeSortIcon: '' });

  const LoadData = () => {
    setIsLoadingAging(true);
    setAgingPaymentReceivedData([]);

    ServerRequestProtected(API_URL + '/Aging_Payment_Received', 'post', {
      "TableName": enumUtil.enumAPITableName.Dashboard,
      "SearchParam": "Aging_Payment_Received",
      ...searchAgingFilterModal
    }).then((response) => {
      setAgingPaymentReceivedData(response);
      setAgingPaymentReceivedDataSorting(response?.[1]);
      handleGridHeaderAging({ defaultData: response?.[1] });
      setReloadChart(prev => !prev);
    }).catch(() => {
    }).finally(() => {
      setIsLoadingAging(false);
    });
  };

  let [
    setOpenAgingFilter,
    searchAgingFilterModal,
    agingFilterDiv,
    setBasedOnDateAging,
    basedOnDateAging,
    setPaymentIDAging,
    paymentForIDAging,
  ] = useDashboardFilterHook(
    LoadData,
    'Aging_Payment_Received', 
    () => {}, 
    null,
    null,
    () => {
      // -- onReset -- //
      setBaseOnAgingDisplay('Date of Service')
    }
  );

  useEffect(() => {
    LoadData();
  }, [basedOnDateAging, paymentForIDAging, reloadData]);

  const handleChange = (e) => {
    setIs(false)
    let { name, value } = e.target;
    if (name === 'BaseOnAging') setBaseOnAgingDisplay(value);
    if (name === 'PaymentForAging') setPaymentForAgingDisplay(value);
  };

  const handleSelectedDataa = (selectedData, name, type) => {
    if (type === 'client' && selectedData) {
        setIs(true);
      if (name === 'BaseOnAging') {
        setBaseOnAgingDisplay(selectedData.display);
        setBasedOnDateAging(selectedData.value + "");
        if (selectedData.value !== basedOnDateAging) setIsLoadingAging(true);
      } else if (name === 'PaymentForAging') {
        setPaymentForAgingDisplay(selectedData.display);
        setPaymentIDAging(selectedData.value + "");
        if (selectedData.value !== paymentForIDAging) setIsLoadingAging(true);
      }
    } else {
      if (name === 'BaseOnAging') setBaseOnAgingDisplay('');
      if (name === 'PaymentForAging') setPaymentForAgingDisplay('');
    }
    return selectedData;
  };

  const agingColumns = [
    {
      key: 'Age', name: 'Age',
      name: (<GridColumnHeader gridHeader={gridHeaderAging} handleGridHeader={handleGridHeaderAging}
        iconName={'iicon-Icon-awesome-user-tie'} headerName={'Age'} sortIcon={true} type={'string'} colKey={'Age'} data={agingPaymentReceivedDataSorting} setData={setAgingPaymentReceivedDataSorting} />),
    },
    ...(isHomeCareCheck ? [] : [{
      key: 'Patient Aging',
      name: (<GridColumnHeader gridHeader={gridHeaderAging} handleGridHeader={handleGridHeaderAging}
        iconName={'iicon-Icon-awesome-user-tie'} headerName={'Patient Aging'} sortIcon={true} type={'string'} colKey={'Patient Aging'} data={agingPaymentReceivedDataSorting} setData={setAgingPaymentReceivedDataSorting} />),
      renderCell: ({ row }) => {
        return (<AmountFormatter amount={row?.['Patient Aging']} />);
      }
    }]),
    {
      key: 'Insurance Aging',
      name: (<GridColumnHeader gridHeader={gridHeaderAging} handleGridHeader={handleGridHeaderAging}
        iconName={'iicon-Icon-awesome-user-tie'} headerName={'Insurance Aging'} sortIcon={true} type={'string'} colKey={'Insurance Aging'} data={agingPaymentReceivedDataSorting} setData={setAgingPaymentReceivedDataSorting} />),
      renderCell: ({ row }) => {
        return (<AmountFormatter amount={row?.['Insurance Aging']} />);
      }
    }
  ];

  return (
    <div className="filter-row border-0 card_tabs p-2">
      <div className="d-flex justify-content-between align-items-center position-relative za_br_light br-bottom-1 pb-1-5 mb-06-px">
        <div className="d-flex align-items-center gap-2">
          <p className="heading text-black fs-15">Aging</p>
        </div>
        <div className="ar_views d-flex cursor-pointer">
          <p className={`${activeTab === 'Graph' ? 'active' : ''}`} onClick={() => setActiveTab('Graph')}>
            <div className="app_tooltip left w-100 h-100 align-items-center justify-content-center">
              <i className="bi-bar-chart-line ar-light-color fs-16 lh-16"></i>
              <p className="tool_tip xsm_text text-light">Graph View</p>
            </div>
          </p>
          <p className={`${activeTab === 'Grid' ? 'active' : ''}`} onClick={() => setActiveTab('Grid')}>
            <div className="app_tooltip right w-100 h-100 align-items-center justify-content-center">
              <i className="bi bi-grid-3x3 fs-16 lh-16 ar-light-color"></i>
              <p className="tool_tip xsm_text text-light">Grid View</p>
            </div>
          </p>
        </div>

        <span className="ar_dash-filter d-flex align-items-center gap-2">
          {isLoadingAging ?
            (<div className="ar-small-loader last_loader">
              <div className="circle circle1"></div>
              <div className="circle circle2"></div>
            </div>) : <></>}
          <div className="w-130px">
            <SuperSearchList
              type="client"
              id='BaseOnAging'
              name='BaseOnAging'
              searchValue={baseOnAgingDisplay}
              is={is}
              data={[
                { value: "EntryDate", display: "Entry Date" },
                { value: "DOS", display: "Date of Service" },
                { value: "SubmittedDate", display: "Submitted" }
              ]}
              onChange={(e) => handleChange(e)}
              getSelectedData={handleSelectedDataa}
              icon={'Simple'}
              sup_btn='sup_btn'
              sup_inp='superSearchVisitInp'
            />
          </div>
          {/* <div className="w-130px">
            <SuperSearchList
              type="client"
              id='PaymentForAging'
              name='PaymentForAging'
              is={is}
              searchValue={PaymentForAgingDisplay}
              data={paymentForList}
              onChange={(e) => handleChange(e)}
              getSelectedData={handleSelectedDataa}
              icon={'Simple'}
              sup_btn='sup_btn'
              sup_inp='superSearchVisitInp'
            />
          </div> */}
          <div className="app_tooltip left">
            <i className="icon-Icon-awesome-filter fs-16" onClick={() => setOpenAgingFilter(prev => !prev)}></i>
            <p className="tool_tip xsm_text text-light">Filters </p>
          </div>
          {activeTab === 'Grid' ?
            agingPaymentReceivedData?.[1] &&
            <DownloadCSVLink name={"AgingPaymentReceivedData.csv"} data={agingPaymentReceivedData?.[1]} columns={agingColumns} /> : <></>}
        </span>
        {agingFilterDiv}
      </div>
      <div>
        {activeTab === 'Graph' ?
          agingPaymentReceivedData?.[0]?.length > 0 ?
            <BarChart key={reloadChart} data={agingPaymentReceivedData?.[0]} type={'Aging'}
              searchedInsuranceIDs={searchAgingFilterModal.SearchCriteria.InsuranceIDs} AgingDateType={searchAgingFilterModal.SearchCriteria.Value} /> :
            <div style={{ height: 205 }}></div> :
          activeTab === 'Grid' ?
            <div>
              <Table
                columns={agingColumns}
                dynamicClass='BorderLess-Grid DataGrid-Table hk-exp-table mt-2 overflow-auto Scroll-width'
                rowHeight={25}
                rows={agingPaymentReceivedDataSorting || []}
                height='205px'
                hidePagination={true}
                isLoading={true}
                hideColClass={'hide'}
              /></div> : <></>}
      </div>
    </div>
  );
});

export default Aging;